module.exports = __webpack_public_path__ + "static/media/Keep Clive Alive.0e1e3921.png";